// Copyright (c) 2016 Deere & Company

import './language-settings.scss';
import React, {PropTypes} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import LanguageSettingsModel from '@deere/cps-it.warranty-model-factory/lib/language-settings';
import Modal from '../../../product/shared/state/modal';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import SettingsHeader from '../../shared/components/settings-header';
import {withRouter} from 'react-router';

let unListen;

function handlePrimaryLanguageChange(primaryLanguageKey) {

    this.actions.updateLanguagePrimaryLanguage(primaryLanguageKey, this.userLanguageSettings.primaryLanguage.allowedPrimaryLanguages);

}

function handleUserSettingsSave() {

    this.actions.updateUserLanguageSettings();

}

function handleConfirmSaveModal() {

    this.actions.confirmSaveModalForLanguageSettings(this.nextLocation);

}

function handleCloseConfirmationModal() {

    this.actions.revertLanguageSelection(this.currentLanguageKey);
    this.actions.closeConfirmSaveModal(this.nextLocation);

}

class LanguageSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        return (
            <section className='language-settings'>
                <SettingsHeader
                    className='language-settings-header'
                    isSaveDisabled={this.props.isSaved}
                    onSave={this.props::handleUserSettingsSave}
                    title='LANGUAGE'
                />
                <section className='language-settings-panel'>
                    <OptionsDropDown
                        className='primary-language'
                        isPlaceholderTranslated={false}
                        label='PRIMARY_LANGUAGE'
                        onChange={this.props::handlePrimaryLanguageChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userLanguageSettings.primaryLanguage.allowedPrimaryLanguages}
                        placeholder='SELECT_LANGUAGE'
                        selectedValue={this.props.userLanguageSettings.primaryLanguage.key}
                    />
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

LanguageSettings.displayName = 'LanguageSettings';
LanguageSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    currentLanguageKey: PropTypes.string.isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userLanguageSettings: PropTypes.instanceOf(LanguageSettingsModel)
};

export default withRouter(LanguageSettings);



// WEBPACK FOOTER //
// ./src/user/language-settings/components/language-settings.js